import {
  Component,
  Output,
  Input,
  EventEmitter,
  ViewChild,
  ElementRef,
} from '@angular/core';
import * as debug from 'debug';
import { AuthProvider } from '../../providers/auth/auth';
import { ToastController } from 'ionic-angular';
import { ToolsProvider } from '../../providers/tools/tools';
import { UserProvider } from '../../providers/user/user';
import { CrudApiProvider } from '../../providers/crud-api/crud-api';
import * as _ from 'lodash';

@Component({
  selector: 'account-info',
  templateUrl: 'account-info.html',
})
export class AccountInfoComponent {
  log = debug('app:AccountInfoComponent');

  loadingIds: any = {};

  @ViewChild('PasswordInput')
  passwordInput;
  @ViewChild('PasswordInput2')
  passwordInput2;
  @ViewChild('OldPasswordInput')
  OldPasswordInput;
  @ViewChild('BioNameInput')
  bioNameInput;
  @ViewChild('FirstNameInput')
  firstNameInput;
  @ViewChild('LastNameInput')
  lastNameInput;
  @ViewChild('UserNameInput')
  userNameInput;
  @ViewChild('EmailInput')
  emailInput;
  @ViewChild('PhoneInput')
  PhoneInput;
  @ViewChild('ZipInput')
  ZipInput;
  @ViewChild('CityStateInput')
  CityStateInput;
  @ViewChild('DOBInput')
  DOBInput;

  @ViewChild('FirstNameLabel')
  firstNameLabel;
  @ViewChild('LastNameLabel')
  lastNameLabel;
  @ViewChild('UserNameLabel')
  userNameLabel;
  @ViewChild('BioLabel')
  bioLabel;
  @ViewChild('EmailLabel')
  emailLabel;
  @ViewChild('PhoneLabel')
  PhoneLabel;
  @ViewChild('ZipLabel')
  ZipLabel;
  @ViewChild('CityStateLabel')
  CityStateLabel;
  @ViewChild('DOBLabel')
  DOBLabel;

  @Input()
  updatePassword = false;
  @Input()
  mode = 'basic'; // this will hide show username for account creation
  @Output()
  invalid = new EventEmitter();
  @Output()
  valid = new EventEmitter();
  @Output()
  focusState = new EventEmitter();
  @Output()
  enter = new EventEmitter();
  @Output() formChanged = new EventEmitter();

  emittedChangesMade = false;

  isSocialOnly = false;
  socialNetwork = '';

  userId: string;
  firstName: string;
  lastName: string;
  username: string;
  bio: '';
  cityState: '';
  bioValidationIssue = '';
  bioValidationState = '';
  email: string;
  zip = '';
  phone = '';
  DOB = '';

  emailValidationState = '';
  userNameValidationState = '';
  userNameValidationIsssue = '';
  passwordValidationState = '';
  password2ValidationState = '';
  bothPasswordsValidationState = '';
  stateIssued = '';

  password = '';
  password2 = '';
  oldPassword = '';

  userTag = '';
  toastOut = false;
  usernameToastMessage = '';
  emailToastMessage = '';
  passwordToastMessage = '';
  maxBioCharacters = 132;
  bioCharactersRemaining = this.maxBioCharacters;

  clicksToEdit = 0;

  accountInfoInvalid = [];

  constructor(
    private authService: AuthProvider,
    private toastCtrl: ToastController,
    private toolsProvider: ToolsProvider,
    public user: UserProvider,
    public crudApi: CrudApiProvider
  ) {
    this.log('AccountInfoComponent Component');
  }

  ngOnInit() {
    // we have had problems with not having 100% data in this modal, this doesn't
    // use the usual provider user update/read
    this.crudApi.get('/api/users/me').then(res => {
      this.user.updateUser(res.data);
      setTimeout(() => {
        this.setUserData();
      });
    });
  }

  ngOnChanges() {
    this.checkAllValid();
  }

  private setUserData() {
    this.userId = this.user.get('_id') || '';
    this.log('userId: ', this.userId, this.user.get());
    this.firstName = this.user.get('firstName') || '';
    this.lastName = this.user.get('lastName') || '';
    this.username = this.user.get('username') || '';
    this.email = this.user.get('email') || '';
    this.bio = this.user.get('bio') || '';
    this.zip = this.user.get('jobSearchInfo.zip') || '';
    this.cityState = this.user.get('cityState') || '';

    this.phone = this.user.get('jobSearchInfo.phone') || '';
    this.DOB = this.user.get('jobSearchInfo.dob') || '';
    this.password = '';
    this.password2 = '';
    this.stateIssued = this.user.get('jobSearchInfo.stateIssued') || '';

    this.updateBioCharCount();

    this.isSocialOnly = this.user.get('metadata.loginInfo.isSocialOnly');
    this.socialNetwork = _.capitalize(
      this.user.get('metadata.loginInfo.socialNetwork')
    );

    this.removeUnauthed();
  }

  checkAllValid() {
    this.log('checking validity');
    if (this.mode === 'all') {
      if (
        this.passwordValidationState === 'valid' &&
        this.password2ValidationState === 'valid' &&
        this.userNameValidationState === 'valid' &&
        this.emailValidationState === 'valid' &&
        this.bioValidationState === 'valid' &&
        this.bothPasswordsValidationState === 'valid' &&
        this.firstName &&
        this.lastName
      ) {
        this.valid.emit(true);
      } else {
        this.invalid.emit(false);
      }
    } else if (this.mode === 'username') {
      if (this.userNameValidationState === 'valid') {
        this.valid.emit(true);
      } else {
        this.invalid.emit(false);
      }
    } else if (this.mode === 'basic') {
      if (
        this.passwordValidationState === 'valid' &&
        this.password2ValidationState === 'valid' &&
        // this.userNameValidationState === 'valid' &&
        this.emailValidationState === 'valid' &&
        this.bioValidationState === 'valid' &&
        this.bothPasswordsValidationState === 'valid' &&
        this.firstName &&
        this.lastName
      ) {
        this.valid.emit(true);
      } else {
        this.invalid.emit(false);
      }
    }
  }

  markAsChanged() {
    if (!this.emittedChangesMade) {
      this.formChanged.emit();
      this.emittedChangesMade = true;
    }
  }

  sendToast(m, type) {
    if (!this.toastOut) {
      this.toastOut = true;
      this.toolsProvider.customToast(m, 4000, 'CustomToast--top');
      setTimeout(() => {
        this.toastOut = false;
      }, 6000);
    }
  }

  // USER NAME PROCEDURES
  usernameCharacterChanged() {
    // this.userNameInput.setElementStyle('border', 'none');
    if (_.size(this.username) < 3) {
      this.userNameValidationState = 'invalid';
      this.userNameValidationIsssue = 'short';
      this.invalid.emit(true);
      this.usernameValidationToast();
      return;
    }
    if (this.toolsProvider.doesStringContainBlockedStrings(this.username)) {
      this.userNameValidationState = 'invalid';
      this.userNameValidationIsssue = 'blockString';
      this.invalid.emit(true);
      this.usernameValidationToast();
      return;
    }

    if (
      String(this.username).toLowerCase() ===
      String(this.user.get('username')).toLowerCase()
    ) {
      this.userNameValidationState = 'valid';
      return; // ok
    }

    this.userNameValidationState = 'checking';
    this.checkAllValid();
    this.log('username changed', this.userNameValidationState);

    let id = (this.loadingIds.username = _.uniqueId());
    this.toolsProvider
      .minimumDelay(this.authService.isUsernameAvailable(this.username), 500)
      .then(res => {
        if (id !== this.loadingIds.username) {
          return;
        }

        this.userNameValidationState = res ? 'valid' : 'invalid';

        if (this.userNameValidationState === 'invalid') {
          this.userNameValidationIsssue = 'taken';
        }
        this.checkAllValid();
        this.usernameValidationToast();
      });
  }

  usernameValidationToast() {
    if (this.userNameValidationState === 'invalid') {
      if (this.userNameValidationIsssue === 'short') {
        this.sendToast(
          'Usernames must be 3 or more characters long.',
          'username'
        );
      } else if (this.userNameValidationIsssue === 'taken') {
        this.sendToast('Sorry, that username is already used.', 'username');
      } else if (this.userNameValidationIsssue === 'blockString') {
        this.sendToast('Username contains invalid characters.', 'username');
      }
    }
  }

  // BIO VALIDATION
  bioChanged() {
    this.updateBioCharCount();
    // if (this.bio.length < this.maxBioCharacters) {
    //   this.bioValidationState = 'valid';
    // } else if (this.bio.length > this.maxBioCharacters) {
    //   this.bioValidationState = 'invalid';
    //   this.bioValidationIssue = 'long';
    //   this.bioValidationToast();
    // }
  }

  updateBioCharCount() {
    this.bioCharactersRemaining = this.maxBioCharacters - this.bio.length;
  }

  // bioValidationToast() {
  //   if (this.bioValidationState === 'invalid') {
  //     if (this.bioValidationIssue === 'long') {
  //       this.sendToast(
  //         `Your bio must be less than ${this.maxBioCharacters} chracters long`,
  //         'bio'
  //       );
  //     }
  //   }
  // }

  // characterUsed() {
  //   this.totalCharacters - 1;
  // }

  // characterDeleted() {
  //   this.totalCharacters + 1;
  // }

  //  EMAIL VALIDATION
  emailCheckValidity() {
    this.checkAllValid();

    this.emailValidationState = 'checking';
    let id = (this.loadingIds.email = _.uniqueId());
    return this.toolsProvider
      .minimumDelay(this.authService.isEmailAddressAvailable(this.email), 500)
      .then(res => {
        if (id !== this.loadingIds.email) {
          return;
        }
        this.log('email valid', res);
        this.emailValidationState = res ? 'valid' : 'invalid';
        if (
          this.emailValidationState === 'invalid' &&
          this.email !== this.user.info.email
        ) {
          this.sendToast('Sorry, that email address is already used.', 'email');
        }
        this.checkAllValid();
      })
      .catch(e => {
        this.log('error', e);
      });
  }

  emailChanged(value) {
    if (!this.validateEmailFormat(this.email)) {
      this.emailValidationState = 'invalid';
      this.invalid.emit(true);
      this.invalidEmailToast();
      this.checkAllValid();
      return;
    }

    this.emailCheckValidity().then(res => {
      if (this.emailValidationState === 'invalid') {
        this.invalid.emit(true);
        this.invalidEmailToast();
      }
    });
  }

  emailCharacterChanged() {
    this.checkAllValid();

    if (!this.validateEmailFormat(this.email)) {
      if (this.email) {
        this.emailValidationState = 'invalid';
        this.invalidEmailToast();
        this.invalid.emit(true);
      }
      return;
    }
    this.emailCheckValidity();
  }

  validateEmailFormat(email) {
    return this.toolsProvider.validEmail(email);
  }

  invalidEmailToast() {
    this.log('invalid toast HERE');
    if (!this.validateEmailFormat(this.email)) {
      this.log('not a valid EMAIL');
      if (!this.toastOut && _.size(this.email) > 6) {
        this.sendToast(
          'The email format is not valid, please try again.',
          'email'
        );
      }
    } else if (this.email !== this.user.info.email) {
      this.log('not a valid EMAIL TAKEN');
      this.sendToast('Sorry, that email address is already used.', 'email');
    }
  }

  // PASSWORD PROCEDURES
  isPasswordValid(password: string): boolean {
    this.log(password);
    if (password.length >= 8 && password.length <= 25) {
      return true;
    }
    return false;
  }

  doPasswordsMatch() {
    return this.password === this.password2;
  }

  validatePassword(doToast?) {
    if (this.isPasswordValid(this.password)) {
      this.passwordValidationState = 'valid';
      this.checkAllValid();
    } else {
      this.passwordValidationState = 'invalid';
      this.invalid.emit(true);

      if (doToast) {
        this.sendToast(
          'Passwords must be between 8 and 25 characters long.',
          'password'
        );
      }
      return;
    }

    if (this.password2) {
      if (this.doPasswordsMatch()) {
        this.bothPasswordsValidationState = 'valid';
        this.checkAllValid();
      } else {
        this.passwordValidationState = 'invalid';
        this.invalid.emit(true);

        if (doToast) {
          this.sendToast('Passwords must match.', 'password');
        }
      }
    }
  }

  passwordChanged() {
    this.validatePassword(true);
  }

  passwordCharacterChanged() {
    this.log('pass and pass2', this.password, this.password2);
    if (this.password.length === 0 && this.password2.length >= 1) {
      this.password2 = '';
      this.passwordValidationState = '';
      this.password2ValidationState = '';
    }
    if (
      this.passwordValidationState === 'invalid' ||
      this.passwordValidationState === 'valid'
    ) {
      this.validatePassword();
    }
  }

  validatePassword2(doToast?) {
    if (this.isPasswordValid(this.password2)) {
      this.password2ValidationState = 'valid';
      this.checkAllValid();
    } else {
      this.password2ValidationState = 'invalid';
      this.invalid.emit(true);

      if (doToast) {
        this.sendToast(
          'Passwords must be at least 8 characters long.',
          'password'
        );
      }
      return;
    }

    if (this.password) {
      if (this.doPasswordsMatch()) {
        this.bothPasswordsValidationState = 'valid';
        this.checkAllValid();
      } else {
        this.password2ValidationState = 'invalid';
        this.invalid.emit(true);

        if (doToast) {
          this.sendToast('Passwords must match.', 'password');
        }
      }
    }
  }

  password2Changed() {
    this.validatePassword2(true);
  }

  password2CharacterChanged() {
    if (this.password2ValidationState === '' && this.password2.length <= 1) {
      return;
    }
    this.validatePassword2();
  }

  // SUBMIT
  enterClick() {
    this.enter.emit();
  }

  submit() {
    if (this.password && this.password2) {
      if (!this.doPasswordsMatch()) {
        return this.sendToast('Passwords must match.', 'password');
      }
    }

    if (this.toolsProvider.doesStringContainBlockedStrings(this.firstName)) {
      return this.sendToast('First name contains invalid characters.', 'name');
    }

    if (this.toolsProvider.doesStringContainBlockedStrings(this.lastName)) {
      return this.sendToast('Last name contains invalid characters.', 'name');
    }

    return {
      firstName: this.firstName,
      lastName: this.lastName,
      username: this.username,
      email: this.email,
      bio: this.bio,
      cityState: this.cityState,
      oldPassword: this.oldPassword,
      password: this.password,
      userTag: this.userTag,
      jobSearchInfo: {
        phone: this.phone,
        zip: this.zip,
        dob: this.DOB,
      },
    };
  }

  emitFocusState(value) {
    this.focusState.emit(value);
  }

  changedZip() {
    this.validateZipCode();
  }

  whichCountry() {
    if (
      _.includes(
        ['AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'ON', 'PE', 'QC', 'SK'],
        this.stateIssued
      )
    ) {
      return 'CA';
    } else if (this.stateIssued) {
      return 'US';
    }
  }

  validateZipCode() {
    if (this.whichCountry() === 'US') {
      this.zip = String(this.zip || '')
        .replace(/[^0-9]/g, '')
        .slice(0, 5);

      if (this.zip && String(this.zip).length !== 5) {
        this.toolsProvider.defaultAlert(
          'Please provide a valid 5-digit zip code.'
        );
      }
    } else if (this.whichCountry() === 'CA') {
      this.zip = String(this.zip || '')
        .slice(0, 6)
        .toUpperCase();

      if (this.zip && String(this.zip).length !== 6) {
        this.toolsProvider.defaultAlert(
          'Please provide a valid 6 character postal code.'
        );

        return;
      }
    } else {
      this.zip = String(this.zip || '')
        .slice(0, 6)
        .toUpperCase();

      if (
        this.zip &&
        (String(this.zip).length < 5 || String(this.zip).length > 6)
      ) {
        this.toolsProvider.defaultAlert('Please provide a valid zip code.');
        return;
      }
    }
  }

  styleInvalidData(accountInfoMissingFormFields: Array<Object>) {
    this.accountInfoInvalid = [];
    this.log('style invalid data: ', accountInfoMissingFormFields);
    _.forEach(accountInfoMissingFormFields, o => {
      this.log('missing fields: ', o);
      this.accountInfoInvalid.push(_.get(o, 'name'));
    });
    setTimeout(() => {
      try {
        if (this.accountInfoInvalid.length) {
          document
            .getElementsByClassName('accountInfoInvalid')[0]
            .scrollIntoView({ behavior: 'smooth' });
        }
      } catch (e) {}
    }, 1000);
    return;
  }

  removeUnauthed() {
    const regexEmail = new RegExp('unauthed.cdllife.com');
    if (regexEmail.test(this.email)) {
      this.email = '';
      this.username = '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/account-info/account-info.ts